"use strict";var r=require("./to-array-e973cad4.js");module.exports=r.toArray;
